<template>
  <span>
    <v-text-field
      v-if="editing"
      :disabled="disabled"
      :maxlength="maxlength"
      :value="text"
      @change="changed"
      :rules="all_rules"
      :label="label"
      ref="atinput"
      validate-on-blur
      @focusout.native="blur"
      :autofocus="autofocus"
      @keydown="checkKey"
    ></v-text-field>
    <span v-else>
      <span v-if="hasTooltip">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{ trxtext.toFixed(decimals) }}</span>
          </template>
          {{ tooltip }}
        </v-tooltip>
      </span>
      <span v-else>{{ trxtext.toFixed(decimals) }}</span>
    </span>
  </span>
</template>

<script>
import ATInputMixin from "./ATInputMixin.js";
import { isEmpty } from "lodash";

export default {
  mixins: [ATInputMixin],
  computed: {
    all_rules() {
      let rules = [];
      if (this.required) rules.push(value => !!value || "Required.");
      return rules;
    },
  },
  methods: {
    checkKey(event) {
      this.$log.debug("--- CHECKKEY ---");
      var keyCode = event.which || event.keyCode;
      var otherKey = event.metaKey || event.altKey || event.ctrlKey;

      var ref = this.$refs.atinput;
      var myinput = ref.$el.querySelector("input");
      this.$log.debug("ref:", ref);
      this.$log.debug("keyCode:", keyCode);
      var cursorPosition = myinput.selectionStart;
      this.$log.debug("cursorPos:" + cursorPosition);

      var val = this.newValue;
      this.$log.debug("1: NEWVALUE: " + val);

      /* Functional, Navigational and Number Keys */
      if (
        otherKey ||
        (keyCode < 48 && (keyCode != 32) & (keyCode != 8)) ||
        (keyCode > 48 && keyCode <= 57) ||
        (keyCode >= 91 && keyCode <= 93) ||
        (keyCode > 96 && keyCode <= 105) ||
        (keyCode >= 112 && keyCode <= 145)
      ) {
        return;
      } else {
        /* Backspace */
        if (keyCode == 8) {
          /* Period or Decimal */
        } else if (keyCode == 110 || keyCode == 190) {
          this.$log.debug("dot!@");
          this.$log.debug(val);

          if (String(val).split(".").length > 1) {
            event.preventDefault();
          }
          /* Zero */
        } else if (keyCode == 48 || keyCode == 96) {
          /* Minus */
        } else if (keyCode == 109 || keyCode == 189) {
          if (cursorPosition != 0 || (!isEmpty(val) && String(val[0]) == "-")) {
            event.preventDefault();
          }
        } else {
          event.preventDefault();
        }
      }
    }
  }
};
</script>